import { appStorage } from "../../firebase";
import {
  deleteObject,
  getDownloadURL,
  ref,
  uploadBytes,
} from "firebase/storage";

export const useImage = () => {
  const upload = async (file: any, setImageURL: any) => {
    if (!file) return;
    const storageRef = ref(
      appStorage,
      `images/${file.name + file.lastModified}`
    );

    if (file === null) {
      console.log("File is not found");
      return;
    }

    await uploadBytes(storageRef, file).catch((e) => {
      console.log(e);
    });

    await getDownloadURL(storageRef).then(async (url) => {
      console.log(url);
      await setImageURL(url);
    });
  };

  const deleteImage = async (url: string) => {
    const storageRef = ref(appStorage, url);
    deleteObject(storageRef);
  };

  return { upload, deleteImage };
};
